import { useAtlasCanvasInputHandler } from "../controls/AtlasCanvasInputHandler";
import { createRef, useCallback, useEffect, useRef, useState } from "react";
import { MutableRefObject } from "react";
import { useSearchParams } from "react-router-dom";
import { Point2d } from "../../../common/geometry/Geom2d";
import AtlasUniverse from "../objects/AtlasUniverse";
import AtlasViewport from "../objects/AtlasViewport";
import useCanvas from "../../../common/hooks/RenderingHooks";
import AtlasPinElement from "../objects/AtlasPinElement";


type Props = {
    atlasUniverse: AtlasUniverse;
    atlasViewport: AtlasViewport;
    className?: string;
    style?: React.CSSProperties;
};

export default function AtlasCanvas({
    atlasUniverse,
    atlasViewport,
    className,
    style,
}: Props): JSX.Element {
    const lastMousePos: Point2d = { x: 0, y: 0 };

    const canvasRef = useCanvas((context: CanvasRenderingContext2D) => {
        const cW = context.canvas.width;
        const cH = context.canvas.height;

        context.fillStyle = "blue";
        context.fillRect(0, 0, cW, cH);

        atlasUniverse.elements.forEach((element) => {
            if (atlasViewport.overlaps(element)) {
                element.draw(context, atlasViewport);
            }
        });

        atlasViewport.draw(context, atlasViewport);
    });

    const onCanvasMouseMove = (e: MouseEvent) => {
        /* console.log(
            { x: e.offsetX, y: e.offsetY },
            atlasViewport.universePointToViewportPoint(
                atlasViewport.viewportPointToUniversePoint({
                    x: e.offsetX,
                    y: e.offsetY,
                })
            )
        ); */
    };

    const onCanvasMouseDrag = (e: MouseEvent) => {
        const newPos = atlasViewport.translate(
            -e.movementX / atlasViewport.magnificationX,
            -e.movementY / atlasViewport.magnificationY
        );
    };

    const onCanvasMouseDown = (e: MouseEvent) => {
        lastMousePos.x = e.offsetX;
        lastMousePos.y = e.offsetY;
    };

    const onCanvasMouseUp = (e: MouseEvent) => {};

    const onCanvasMouseWheel = (e: WheelEvent) => {
        const scroll = e.deltaY;

        if (scroll > 0) {
            atlasViewport.magnify(1 - 0.1, {
                x: e.offsetX,
                y: e.offsetY,
            });
        } else {
            atlasViewport.magnify(1 + 0.1, {
                x: e.offsetX,
                y: e.offsetY,
            });
        }
    };

    const onCanvasKeyPress = (e: KeyboardEvent) => {
    };

    const onCanvasKeyDown = (e: KeyboardEvent) => {
        if(e.key === "Shift") {
            atlasUniverse.elements.forEach(element => {
                if(element instanceof AtlasPinElement) {
                    if(typeof(element.drawTitle) === "boolean") {
                        element.drawTitle = true;
                    }
                }
            });
        }
    };

    const onCanvasKeyUp = (e: KeyboardEvent) => {
        if(e.key === "Shift") {
            atlasUniverse.elements.forEach(element => {
                if(element instanceof AtlasPinElement) {
                    if(typeof(element.drawTitle) === "boolean") {
                        element.drawTitle = false;
                    }
                }
            });
        }
    };

    useAtlasCanvasInputHandler(canvasRef, {
        onMouseMove: onCanvasMouseMove,
        onMouseDrag: onCanvasMouseDrag,
        onMouseDown: onCanvasMouseDown,
        onMouseUp: onCanvasMouseUp,
        onMouseWheel: onCanvasMouseWheel,
        onKeyPress: onCanvasKeyPress,
        onKeyDown: onCanvasKeyDown,
        onKeyUp: onCanvasKeyUp,
    });

    return (
        <canvas
            width={style?.width ?? undefined}
            height={style?.height ?? undefined}
            ref={canvasRef}
            className={`atlas-canvas${className == null ? "" : className}`}
            style={style}
        />
    );
}
